import { CSSProperties, ReactNode } from 'react'

import {
  GreyGrey10,
  GreyGrey30,
  GreyWhite,
  Spinner,
  Center,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import { isSavePendingAtom } from 'Invoices/atoms/invoiceEditing.atom'

type Props = {
  name: ReactNode
  qty?: ReactNode
  rate?: ReactNode
  tax?: ReactNode
  amount?: ReactNode
  action?: ReactNode
  hideBorder?: boolean
  dragHandle?: ReactNode
  unsynced?: boolean
  onClick?: () => void
  style?: CSSProperties
  'data-testid'?: string
}

export const Row = (props: Props) => {
  const gridItemStyle = {
    borderBottom: props.hideBorder ? undefined : `${GreyGrey30} 1px solid`,
    display: 'flex',
    alignItems: 'flex-start'
  }

  const isSavePending = useAtomValue(isSavePendingAtom)

  const isDisabled = isSavePending || !!props.unsynced

  return (
    <Grid
      className="group"
      gridTemplateColumns={`266fr 60fr 76fr 44fr 144fr ${props.action ? '32px' : '0px'}`}
      background={GreyWhite}
      _hover={props.onClick && !isDisabled ? { background: GreyGrey10 } : {}}
      position="relative"
      opacity={isDisabled ? 0.5 : 1}
      onClick={() => {
        if (isDisabled) return
        props.onClick?.()
      }}
      cursor={props.onClick && !isDisabled ? 'pointer' : 'default'}
      style={props.style}
      data-testid={props['data-testid']}
    >
      {props.dragHandle}
      <GridItem {...gridItemStyle}>{props.name}</GridItem>
      <GridItem {...gridItemStyle}>{props.qty}</GridItem>
      <GridItem {...gridItemStyle} justifyContent="flex-end">
        {props.rate}
      </GridItem>
      <GridItem {...gridItemStyle} justifyContent="flex-end">
        {props.tax}
      </GridItem>
      <GridItem
        {...gridItemStyle}
        justifyContent="flex-end"
        gridColumn={!props.action ? 'span 2' : undefined}
      >
        {props.amount}
      </GridItem>
      {props.unsynced && (
        <Center>
          <Spinner width="16px" height="16px" color={GreyGrey30} />
        </Center>
      )}
      {props.action && !isDisabled ? (
        <GridItem {...gridItemStyle} alignItems="center">
          {props.action}
        </GridItem>
      ) : null}
    </Grid>
  )
}
